import { render, staticRenderFns } from "./viewContract.vue?vue&type=template&id=70d8fe1c&scoped=true"
import script from "./viewContract.vue?vue&type=script&lang=js"
export * from "./viewContract.vue?vue&type=script&lang=js"
import style0 from "./viewContract.vue?vue&type=style&index=0&id=70d8fe1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8fe1c",
  null
  
)

export default component.exports